import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { RacingsContext } from '@racings/store/context';
import { SportTypesUrls } from '@racings/constants/enums/sportTypes';
import { RacingsList } from './racingsList';
import { Filter } from './filter';

const RacingMain = ({ routePrefix = '' }) => {
  const [, setRacingsState] = useContext(RacingsContext);
  const { sportType } = useParams();
  const navigate = useNavigate();
  useEffect(() => () => setRacingsState((old) => ({
    ...old,
  })), [setRacingsState]);

  useEffect(() => {
    if (!sportType) navigate(`${routePrefix}/${SportTypesUrls.HORSE}/upComing`);
  }, [sportType]);

  return (
    <>
      <div className="racings-list-header">
        <Filter />
      </div>
      <RacingsList routePrefix={routePrefix} />
    </>
  );
};

export default RacingMain;
